import React, { useContext } from 'react';
import './Navbar.css';
import { themeContext } from '../../Context';
import { Link } from 'react-scroll';

const Navbar = () => {

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className="n-wrapper">
        <div className="n-left">
            <div className="n-brand">
                <span className="n-logo">&lt;/&gt;</span>
                <div className="n-name" style={{color: darkMode ? 'white' : ''}}>Portfolio</div>
            </div>
        </div>
        <div className="n-right">
            <div className="n-list">
                <ul style={{listStyleType:'none'}}>
                    <Link spy={true} to={'Navbar'} smooth={true} activeClass='activeClass'>
                        <li>Home</li>
                    </Link>
                    <Link spy={true} to={'Services'} smooth={true}>
                        <li>Services</li>
                    </Link>

                    <Link spy={true} to={'Experience'} smooth={true} >
                        <li>Experience</li>
                    </Link>
                    
                    <Link spy={true} to={'Projects'} smooth={true} >
                        <li>Projects</li>
                    </Link>
                    
                </ul>
            </div>
            <Link spy={true} to={'Contact'} smooth={true} >
                <button className="button n-button">
                    Contact <span aria-hidden="true">-&gt;</span>
                </button>
            </Link>

        </div>
    </div>
  )
}

export default Navbar
